import { Chip, Divider, Tooltip, Typography } from "@mui/material";
import { Box, useTheme } from "@mui/system";
import useStyles from "./styles";
import dayjs from "dayjs";

export default function MetricaApiComponent(params) {
  const {
    apiName = "",
    tempo = null,
    index = null,
    dataApisFilter = [],
    dias = [],
    analiseAtividadeApiDay = () => {},
    analiseAtividadeApi = () => {},
    windowWidth = null,
    apiConfigs = [],
  } = params;

  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <Box sx={styles.containerApi}>
      <Box sx={styles.containerTituloApi}>
        <Box sx={styles.containerColorApi} bgcolor={apiConfigs[index]?.color} />

        <Typography sx={styles.apiTitulo}>{apiName}</Typography>
      </Box>

      <Box sx={styles.containerAnaliseApi}>
        {Array.isArray(dataApisFilter?.slice(-tempo)) &&
          dataApisFilter?.map((dataApi, indexApi) => {
            return (
              <Tooltip
                arrow
                PopperProps={{
                  modifiers: [
                    {
                      name: "preventOverflow",
                      options: {
                        boundary: "viewport",
                      },
                    },
                  ],
                }}
                componentsProps={styles.tooltipStyles}
                title={
                  dataApi[index]?.length > 0 ? (
                    <>
                      <Box sx={styles.containerData}>
                        <Typography sx={styles.tituloData}>
                          {dataApi[index]?.length > 0
                            ? dataApi &&
                              dayjs(dataApi[index][0]?.createAt).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Typography>
                      </Box>

                      <Box sx={styles.containerRequisicao}>
                        <Box sx={styles.containerStatusRequisicao} />

                        <Typography sx={styles.tituloRequisicao}>
                          Requisições bem-sucessidas:{" "}
                          {
                            dataApi[index]?.filter(
                              (data) =>
                                data?.httpCode === 200 || data?.httpCode === 201
                            ).length
                          }{" "}
                        </Typography>
                      </Box>

                      <Box sx={styles.containerFalha}>
                        <Box sx={styles.containerStatusFalha} />
                        <Typography sx={styles.tituloRequisicao}>
                          Requisições com falhas:{" "}
                          {dataApi[index]?.length -
                            dataApi[index]?.filter(
                              (data) =>
                                data?.httpCode === 200 || data?.httpCode === 201
                            )?.length}
                        </Typography>
                      </Box>
                      {dataApi[index]?.filter(
                        (data) =>
                          data?.httpCode !== 200 && data?.httpCode !== 201
                      )?.length !== 0 && (
                        <Box sx={styles.containerIncidentes}>
                          <Typography sx={styles.tituloData}>
                            Incidentes do dia
                          </Typography>
                          {dataApi[index]
                            ?.filter(
                              (data) =>
                                data?.httpCode !== 200 && data?.httpCode !== 201
                            )
                            ?.map((api) => (
                              <>
                                <Box sx={styles.containerStatusIncidentes}>
                                  <Typography sx={styles.tituloRequisicao}>
                                    {dayjs(api?.createAt).format(
                                      "DD/MM/YY HH:mm"
                                    )}
                                  </Typography>
                                  <Typography sx={styles.tituloRequisicao}>
                                    Status: {api?.httpCode}
                                  </Typography>
                                </Box>
                                <Divider />
                              </>
                            ))}
                        </Box>
                      )}
                    </>
                  ) : (
                    <>
                      <Box sx={styles.containerSemDados}>
                        <Typography sx={styles.tituloData}>
                          {dayjs(dias[indexApi]?.data)?.format("DD/MM/YYYY")}
                        </Typography>
                      </Box>

                      <Typography sx={styles.tituloRequisicao}>
                        Sem dados para esse período
                      </Typography>
                    </>
                  )
                }
              >
                <Box
                  bgcolor={
                    dataApi[index]?.length > 0
                      ? analiseAtividadeApiDay(
                          dataApi[index]?.filter(
                            (data) =>
                              data?.httpCode === 200 || data?.httpCode === 201
                          )?.length,
                          dataApi[index]?.length
                        ) > 90
                        ? theme.palette.colors.green.light
                        : analiseAtividadeApiDay(
                            dataApi[index]?.filter(
                              (data) =>
                                data?.httpCode === 200 || data?.httpCode === 201
                            ).length,
                            dataApi[index]?.length
                          ) > 80
                        ? theme.palette.colors.yellow.dark
                        : theme.palette.colors.red.dark
                      : theme.palette.mode === "dark"
                      ? theme.palette.colors.black.medium
                      : theme.palette.colors.black.light
                  }
                  sx={{
                    ...styles.containerDia,
                    width: windowWidth < 1829 ? "7px" : "5px",
                  }}
                />
              </Tooltip>
            );
          })}
      </Box>
      <Box sx={styles.containerAnaliseDias}>
        <Box sx={{ minWidth: "60px" }}>
          <Typography sx={styles.tituloDias}>Há {tempo} dias</Typography>
        </Box>
        <Box sx={styles.containerDivider}>
          <Divider variant="fullWidth">
            <Chip
              label={`${analiseAtividadeApi(
                dataApisFilter?.slice(-tempo),
                index
              )}% em atividade`}
              size="small"
              sx={{
                bgcolor:
                  analiseAtividadeApi(dataApisFilter?.slice(-tempo), index) > 90
                    ? theme.palette.colors.green.light
                    : analiseAtividadeApi(
                        dataApisFilter?.slice(-tempo),
                        index
                      ) > 80
                    ? theme.palette.colors.yellow.dark
                    : theme.palette.colors.red.dark,
                color: theme.palette.white.main,
                fontWeight: "bold",
              }}
            />
          </Divider>
        </Box>
        <Box sx={styles.containerHoje}>
          <Typography sx={styles.tituloDias}>Hoje</Typography>
        </Box>
      </Box>
    </Box>
  );
}
